import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { setShowAlertsGetter } from './globalNotifications';

type Ctx = {
  showAlerts: boolean;
  setShowAlerts: (v: boolean) => void;
};

const NotificationContext = createContext<Ctx | undefined>(undefined);
const STORAGE_KEY = 'showAlerts';

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showAlerts, setShowAlerts] = useState<boolean>(() => {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw === null ? true : raw === 'true';
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, String(showAlerts));
    setShowAlertsGetter(() => showAlerts);
  }, [showAlerts]);

  const value = useMemo(() => ({ showAlerts, setShowAlerts }), [showAlerts]);
  return <NotificationContext.Provider value={value}>{children}</NotificationContext.Provider>;
};

export const useNotification = (): Ctx => {
  const ctx = useContext(NotificationContext);
  if (!ctx) throw new Error('useNotification must be used within NotificationProvider');
  return ctx;
};
